import Vue from "vue";
import VueI18n from "vue-i18n";
import translations from "@/assets/i18n/vue.json";
import { getI18NJsonConfig, languages_info } from "@/services/localizations";
import { changeLocale as changeLocaleVuetify } from "@/plugins/vuetify";
import { localeChanged as localeChangedVee } from "vee-validate";

Vue.use(VueI18n);

//initial translations
const messages = {};
for (const [key, value] of Object.entries(translations)) {
  import(`vee-validate/dist/locale/${key}.json`)
    .then(locale => {
      messages[key] = {
        ...value,
        validation: locale.messages
      };
    })
    .catch(e => {
      const lang_without_country = languages_info[key].without_country;
      import(`vee-validate/dist/locale/${lang_without_country}.json`).then(
        locale => {
          messages[key] = {
            ...value,
            validation: locale.messages
          };
        }
      );
    });
}

const i18n = new VueI18n({
  locale: "pt_PT",
  messages,
  fallbackLocale: ["en_US", "pt_PT"]
});

export function setI18nLanguage(lang) {
  i18n.locale = lang.id;
  Vue.prototype.$http.defaults.headers.common["Content-Language"] = lang.id;
  Vue.prototype.$moment.locale(lang.without_country);
  document.querySelector("html").setAttribute("lang", lang.id);
  localeChangedVee();
  changeLocaleVuetify(lang.without_country);
  return lang;
}

let initiallyLoaded = false;

export function loadLanguagesAsync() {
  // If the language hasn't been loaded yet

  return new Promise((resolve, reject) => {
    if (!initiallyLoaded) {
      getI18NJsonConfig()
        .then(loaded_translations => {
          for (const [key, value] of Object.entries(loaded_translations)) {
            import(`vee-validate/dist/locale/${key}.json`)
              .then(locale => {
                i18n.setLocaleMessage(key, {
                  ...value,
                  validation: locale.messages
                });
              })
              .catch(e => {
                const lang_without_country = languages_info[key].without_country;
                import(
                  `vee-validate/dist/locale/${lang_without_country}.json`
                ).then(locale => {
                  i18n.setLocaleMessage(key, {
                    ...value,
                    validation: locale.messages
                  });
                });
              });
          }

          initiallyLoaded = true;
          resolve(true);
        })
        .catch(error => reject(error));
    } else {
      resolve(true);
    }
  });
}

export default i18n;
